
import { defineComponent, reactive } from 'vue'
import { useRouter } from 'vue-router'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'
import FileReader from '@/common/components/UI/FileReader/index.vue'
import Alert from '@/common/components/UI/Alert/index.vue'

// quill
import { QuillEditor } from '@vueup/vue-quill'
import ImageUploader from 'quill-image-uploader'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

// validation
import useVuelidate from '@vuelidate/core'
import { required, maxLength, integer } from '@vuelidate/validators'

// realisations
import { cases } from '@/core/realisations/cases.realisation'
import { vacancyUploadFile } from '@/new-services/files.service'

// composable
import useNotifications from '@/common/composable/useNotifications'

const TITLE_MAX_LENGTH = 110

const STATUSES = [
    { id: 1, name: 'Активный' },
    { id: 2, name: 'Не активный' }
]

export default defineComponent({
    components: {
        PageTitle,
        TheButton,
        TheInput,
        TheSelect,
        FileReader,
        'quill-editor': QuillEditor,
        Alert
    },
    setup() {
        const notifications = useNotifications()
        const router = useRouter()

        const state = reactive({
            is_loading: false,
            statusId: null as number | null,
            shortTitle: null as string | null,
            title: null as string | null,
            feedbackHeader: null as string | null,
            shortDescription: null as string | null,
            description: null as string | null,
            previewImage: [] as File[],
            mainImage: [] as File[],
            order: null as string | null,
            titleForDisplay: null as string | null,
            descriptionForDisplay: null as string | null,
        })

        const state_form$ = useVuelidate({
            statusId: { required },
            shortTitle: { required, maxLength: maxLength(TITLE_MAX_LENGTH) },
            title: { required },
            feedbackHeader: { required },
            description: { required },
            shortDescription: { required },
            previewImage: { required },
            mainImage: { required },
            order: { required, integer },
        }, state)

        const submit = async () => {
            if (state.is_loading) return

            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            try {
                state.is_loading = true

                const formData = new FormData()
                formData.append('statusId', (state.statusId as number).toString())
                formData.append('shortTitle', state.shortTitle as string)
                formData.append('title', state.title as string)
                formData.append('feedbackHeader', state.feedbackHeader as string)
                formData.append('shortDescription', state.shortDescription as string)
                formData.append('description', state.description as string)
                formData.append('previewImage', state.previewImage[0])
                formData.append('mainImage', state.mainImage[0])
                formData.append('order', state.order as string)
                
                if (state.titleForDisplay) {
                    formData.append('titleForDisplay', state.titleForDisplay as string)
                }

                if (state.descriptionForDisplay) {
                    formData.append('descriptionForDisplay', state.descriptionForDisplay as string)
                }

                await cases.createCase(formData)

                router.push('/cases')
            } catch (error) {
                console.error(error)
                notifications.notifyError({ error, title: 'При добавлении кейса произошла ошибка' })
            } finally {
                state.is_loading = false
            }
        }

        const quillModules = {
            name: 'imageUploader',
            module: ImageUploader,
            options: {
                upload: (file: File) => {
                    return new Promise(async (resolve, reject) => {
                        try {
                            const form_data = new FormData()
                            form_data.append('file', file)
                            const { data } = await vacancyUploadFile(form_data)

                            resolve(data.data.url)
                        } catch (error) {
                            notifications.notifyError({ error, title: 'При загрузке изображения произошла ошибка' })
                            reject(error)
                        }
                    })
                }
            }
        }

        return { state, state_form$, submit, STATUSES, quillModules }
    }
})
